import { Version } from "./lib/runtime.js";
const frameworkIdentifier = {
  name: "next-axiom-version",
  version: Version
};
const frameworkIdentifierFormatter = (logEvent) => {
  return {
    ...logEvent,
    "@app": {
      [frameworkIdentifier.name]: frameworkIdentifier.version
    }
  };
};
export {
  frameworkIdentifier,
  frameworkIdentifierFormatter
};
//# sourceMappingURL=identifier.js.map
